<template>
  <main class="main main--has-floating-buttons">
    <template v-if="dataLoaded === true">
      <portal to="headerTitle">
        {{ discountCode.code }}
      </portal>

      <card :title="$t('admin.pageDiscountCode.card.code')" cols="12 6@desktop start-1">
        <hm-input v-model="discountCode.code"
                  :lazy="true"
                  :disabled="discountCode.deleted"
                  :label="$t('admin.pageDiscountCode.code')"
                  validate="required"
                  name="code"
                  cols="12 6@tablet start-1" />

        <hm-input-money v-model="discountCode.percentage"
                        :disabled="discountCode.deleted"
                        :lazy="true"
                        :label="$t('admin.pageDiscountCode.percentage')"
                        :digits="2"
                        currency="%"
                        validate="required"
                        name="percentage"
                        cols="12 6@tablet start-1" />

        <!--        <hm-input-money v-model="discountCode.amount"-->
        <!--                        :disabled="discountCode.deleted"-->
        <!--                        :lazy="true"-->
        <!--                        :label="$t('admin.pageDiscountCode.amount')"-->
        <!--                        :help="$t('admin.pageDiscountCode.amount_help')"-->
        <!--                        :digits="2"-->
        <!--                        :currency="hotelSettings.details.currency"-->
        <!--                        validate="required"-->
        <!--                        name="amount"-->
        <!--                        cols="12 6@tablet start-1" />-->

        <hm-multiselect id="ratePlans"
                        v-model="discountCode.applicableRatePlans"
                        :options="hotelSettings.ratePlans.all(discountCode.applicableRatePlans)"
                        :disabled="discountCode.deleted"
                        :label="$t('admin.pageDiscountCode.applicableRatePlans')"
                        :limit="99"
                        cols="12 start-1"
                        name="applicableRatePlans"
                        label-expression="${option.name[$shortLocale]}">

          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-tooltip="{ title: $t('admin.pageDiscountCode.unselectAll'), delay: 0, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }"
                               :border="true"
                               :disabled="false"
                               icon="close"
                               @click="discountCode.applicableRatePlans = []" />
            <input-icon-button v-tooltip="{ title: $t('admin.pageDiscountCode.selectAll'), delay: 0, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }"
                               :border="true"
                               :disabled="false"
                               icon="select-all"
                               @click="discountCode.applicableRatePlans = hotelSettings.ratePlans.all().map(it => it.id)" />
          </template>
        </hm-multiselect>

        <hm-multiselect id="roomTypes"
                        v-model="discountCode.applicableRoomTypes"
                        :options="hotelSettings.roomTypes.all(discountCode.applicableRoomTypes)"
                        :disabled="discountCode.deleted"
                        :label="$t('admin.pageDiscountCode.applicableRoomTypes')"
                        :limit="99"
                        cols="12 start-1"
                        name="applicableRoomTypes"
                        label-expression="${option.name[$shortLocale]}">

          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-tooltip="{ title: $t('admin.pageDiscountCode.unselectAll'), delay: 0, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }"
                               :border="true"
                               :disabled="false"
                               icon="close"
                               @click="discountCode.applicableRoomTypes = []" />
            <input-icon-button v-tooltip="{ title: $t('admin.pageDiscountCode.selectAll'), delay: 0, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }"
                               :border="true"
                               :disabled="false"
                               icon="select-all"
                               @click="discountCode.applicableRoomTypes = hotelSettings.roomTypes.all().map(it => it.id)" />
          </template>
        </hm-multiselect>
      </card>

      <!--      <tabable-card cols="12 6@desktop start-1">-->
      <!--        <tabable-card-content :title="$t(`lang.${hotelSettings.details.primaryLanguage}`)">-->
      <!--          <hm-card-inner>-->
      <!--            <hm-textarea v-model="discountCode.description[hotelSettings.details.primaryLanguage]"-->
      <!--                         :lazy="true"-->
      <!--                         :disabled="discountCode.deleted"-->
      <!--                         :label="$t('admin.pageDiscountCode.description')"-->
      <!--                         name="description"-->
      <!--                         cols="12" />-->
      <!--          </hm-card-inner>-->
      <!--        </tabable-card-content>-->
      <!--      </tabable-card>-->
      <!--      <tabable-card cols="12 6@desktop">-->
      <!--        <tabable-card-content v-for="lang in hotelSettings.details.additionalLanguages" :title="$t(`lang.${lang}`)" :key="lang">-->
      <!--          <hm-card-inner>-->
      <!--            <hm-textarea v-model="discountCode.description[lang]"-->
      <!--                         :lazy="true"-->
      <!--                         :disabled="discountCode.deleted"-->
      <!--                         :label="$t('admin.pageDiscountCode.description')"-->
      <!--                         name="description"-->
      <!--                         cols="12" />-->
      <!--          </hm-card-inner>-->
      <!--        </tabable-card-content>-->
      <!--      </tabable-card>-->

      <card :title="$t('admin.pageDiscountCode.card.restrictions')" cols="12 6@desktop">
        <hm-input-number v-model="discountCode.minLOS"
                         :validate="`max_value:${discountCode.maxLOS || 365}|min_value:1`"
                         :label="$t('seasonRateEditor.seasonRestrictionEditor.minLOS')"
                         :help="$t('seasonRateEditor.seasonRestrictionEditor.minLOS_help')"
                         cols="12 6@tablet start-1"
                         name="minLOS"/>
        <hm-input-number v-model="discountCode.maxLOS"
                         :validate="`min_value:${discountCode.minLOS || 1}`"
                         :label="$t('seasonRateEditor.seasonRestrictionEditor.maxLOS')"
                         :help="$t('seasonRateEditor.seasonRestrictionEditor.maxLOS_help')"
                         cols="12 6@tablet start-1"
                         name="maxLOS"/>
        <hm-input-number v-if="hasLicense('LeadTimeToBook')"
                         v-model="discountCode.minLeadTimeToBook"
                         :label="$t('seasonRateEditor.seasonRestrictionEditor.minLeadTimeToBook')"
                         :help="$t('seasonRateEditor.seasonRestrictionEditor.minLeadTimeToBook_help')"
                         cols="12 6@tablet start-1"
                         name="minLeadTimeToBook"/>
        <hm-input-number v-if="hasLicense('LeadTimeToBook')"
                         v-model="discountCode.maxLeadTimeToBook"
                         :label="$t('seasonRateEditor.seasonRestrictionEditor.maxLeadTimeToBook')"
                         :help="$t('seasonRateEditor.seasonRestrictionEditor.maxLeadTimeToBook_help')"
                         cols="12 6@tablet start-1"
                         name="maxLeadTimeToBook"/>
      </card>

      <card :title="$t('admin.pageDiscountCode.card.stayDateRanges')" cols="12 6@desktop">
        <hm-card-inner v-for="it in discountCode.stayDateRanges" :key="it.id" :deletable="true" @delete="deleteElement('stayDateRanges', it)">
          <hm-input-date v-model="it.startDate"
                         :required="false"
                         :label="$t('admin.pageDiscountCode.startDate')"
                         cols="12 4@tablet"
                         name="startDate" />
          <hm-input-date v-model="it.endDate"
                         :min-date="it.startDate"
                         :max-days="36500"
                         :required="false"
                         :label="$t('admin.pageDiscountCode.endDate')"
                         cols="12 4@tablet"
                         name="endDate" />
        </hm-card-inner>
      </card>

      <card :title="$t('admin.pageDiscountCode.card.bookingDateRanges')" cols="12 6@desktop">
        <hm-card-inner v-for="it in discountCode.bookingDateRanges" :key="it.id" :deletable="true" @delete="deleteElement('bookingDateRanges', it)">
          <hm-input-date v-model="it.startDate"
                         :required="false"
                         :label="$t('admin.pageDiscountCode.startDate')"
                         cols="12 4@tablet"
                         name="startDate" />
          <hm-input-date v-model="it.endDate"
                         :min-date="it.startDate"
                         :max-days="36500"
                         :required="false"
                         :label="$t('admin.pageDiscountCode.endDate')"
                         cols="12 4@tablet"
                         name="endDate" />
        </hm-card-inner>
      </card>

      <hm-floating-buttons id="actions" ref="floatingButtons">
        <hm-floating-button v-if="!discountCode.deleted"
                            :label="$t('admin.pageDiscountCode.actions.deleteDiscountCode')"
                            icon="delete"
                            color="error"
                            @click="deleteDiscountCode(false)" />
      </hm-floating-buttons>
    </template>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import uuid from 'uuid';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, groupBy, isEmpty, isNil, keyBy, sortBy, size } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import HmFloatingButton from '../../lib/inputs/HmFloatingButton';
import HmCardInner from '../../lib/layout/HmCardInner';
import HmMultiselect from '../../lib/inputs/HmMultiselect';
import HmInputDate from '../../lib/inputs/HmInputDate';
import HmTextarea from '../../lib/inputs/HmTextarea.vue';
import AutoAddNewRowsMixin from '../../../mixins/AutoAddNewRowsMixin';
import HmInputNumber from '../../lib/inputs/HmInputNumber.vue';

export default {
  name: 'PageDiscountCode',
  components: { HmInputNumber, HmTextarea, HmInputDate, HmMultiselect, HmCardInner, HmFloatingButton },
  autosave: [
    {
      name: 'discountCode',
      variable: 'discountCode',
      event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        if (this.discountCode.deleted === true) {
          cbSaveComplete();
          return;
        }

        const toSave = cloneDeep(this.discountCode);

        toSave.stayDateRanges = toSave.stayDateRanges.filter(it => !isNil(it.startDate) || !isNil(it.endDate));
        toSave.bookingDateRanges = toSave.bookingDateRanges.filter(it => !isNil(it.startDate) || !isNil(it.endDate));

        this.axios.put(this.serviceUrls.discountCode.get(this, this.discountCodeId), toSave)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();

            this.$serviceBus.$emit('discountCode.list');
          })
          .catch((error) => {
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  mixins: [HotelmeisterMixin, SaveWatchMixin, AutoAddNewRowsMixin],

  data() {
    return {
      discountCodeId: this.$route.params.discountCodeId,
      discountCode: { },
      dataLoaded: false,
    };
  },

  computed: {
  },

  watch: {
    discountCode: function (newVal) {
      if (isNil(newVal)) {
        this.dataLoaded = false;
      }
    },
    'discountCode.stayDateRanges': {
      handler: function () {
        this.autoAddNewRows(
          this.discountCode.stayDateRanges,
          {
            startDate: null,
            endDate: null,
            id: uuid.v4(),
          },
          it => isEmpty(it.startDate) && isEmpty(it.endDate),
        );
      },
      deep: true,
    },
    'discountCode.bookingDateRanges': {
      handler: function () {
        this.autoAddNewRows(
          this.discountCode.bookingDateRanges,
          {
            startDate: null,
            endDate: null,
            id: uuid.v4(),
          },
          it => isEmpty(it.startDate) && isEmpty(it.endDate),
        );
      },
      deep: true,
    },
  },

  created: function () {
    this.loadData();
    this.$serviceBus.$emit('discountCode.list');
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.discountCode.get(this, this.discountCodeId))
        .then((response) => {
          if (this.dataLoaded === false) {
            const discountCode = response.data.data;
            if (!isNil(discountCode.seasonalValidFrom)) {
              discountCode.seasonalValidFrom = this.$moment(`${discountCode.seasonalValidFrom[0]}-${discountCode.seasonalValidFrom[1]}`, 'DD-MM').format(this.dayMonthFormat);
            }
            if (!isNil(discountCode.seasonalValidUntil)) {
              discountCode.seasonalValidUntil = this.$moment(`${discountCode.seasonalValidUntil[0]}-${discountCode.seasonalValidUntil[1]}`, 'DD-MM').format(this.dayMonthFormat);
            }
            this.discountCode = discountCode;
            this.dataLoaded = true;
          }
        });
    },
    deleteDiscountCode(confirmed = false) {
      if (confirmed === true) {
        this.axios.delete(this.serviceUrls.discountCode.get(this, this.discountCodeId))
          .then((response) => {
            this.dataLoaded = false;
            this.discountCode = response.data.data;
            this.showSuccessMessage();
            this.$serviceBus.$emit('discountCode.list');
            this.$router.push({
              name: 'discountCodes',
            });
          })
          .catch((error) => {
            this.showMessages(error.response);
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
          });
      } else {
        this.showConfirmModal(
          this.$t('admin.pageDiscountCode.confirmDeleteDiscountCode'),
          (doNotShowAgain) => {
            this.deleteDiscountCode(true);
          },
        );
      }
    },
    deleteElement(variable, it) {
      // console.log(this.discountCode[variable]);
      this.discountCode[variable].splice(this.discountCode[variable].indexOf(it), 1);
      // console.log(this.discountCode[variable]);
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageDiscountCode.vue